import React from 'react';
import './hosLogActionsBar.scss';
import { useSelector } from 'react-redux';
import {
  getHosLogsUncertified,
  getHosLogsWithMissingInfo,
  getHosLogsWithPendingEdits,
  getHosLogsWithViolations,
} from 'src/features/hosLogs/store';

const HosLogsActionsBar: React.FC = () => {
  const uncertifiedLogs = useSelector(getHosLogsUncertified);
  const hosLogsWithViolations = useSelector(getHosLogsWithViolations);
  const hosLogsWithPendingEdits = useSelector(getHosLogsWithPendingEdits);
  const hosLogsWitMissingInfo = useSelector(getHosLogsWithMissingInfo);

  return (
    <div className="hos-actions-bar-ctn">
      <div className="actions-header">Log Actions</div>
      <div className="all-actions-row">
        <ActionSummary count={String(hosLogsWithViolations?.length)} text="Violations" />
        <ActionSummary count={String(hosLogsWithPendingEdits?.length)} text="Pending Edits" />
        <ActionSummary
          count={String(hosLogsWitMissingInfo?.length)}
          text="Logs With Missing Info"
        />
        <ActionSummary count={String(uncertifiedLogs?.length)} text="Uncertified Logs" />
      </div>
    </div>
  );
};

const ActionSummary = ({ count, text }: { count: string; text: string }) => {
  return (
    <div className="single-action-ctn">
      <p className="action-count">{count}</p>
      <p className="action-text">{text}</p>
    </div>
  );
};

export default HosLogsActionsBar;
